// Traduction anglaise de l'interface (espace élève et éléments communs).
// Clé : texte français tel qu'affiché (espaces normalisés) ; valeur : texte anglais.
// Les contenus pédagogiques (leçons, énoncés, messages) ne sont pas traduits.
import EN_ESPACES from "./enEspaces";

const EN_ELEVE = {
  // ── Paramètres ──
  "Paramètres": "Settings",
  "Langue": "Language",
  "Langue de l'application": "App language",
  "Français": "French",
  "English": "English",
  "Apparence": "Appearance",
  "Mode clair": "Light mode",
  "Mode nuit": "Dark mode",
  "Automatique (comme le téléphone)": "Automatic (follow the device)",
  "Son des notifications": "Notification sound",
  "Jouer un son quand une notification arrive": "Play a sound when a notification arrives",
  "Les leçons, énoncés et messages restent dans leur langue d'origine.": "Lessons, exercise statements and messages stay in their original language.",
  "Ces réglages sont enregistrés sur cet appareil.": "These settings are saved on this device.",
  "Tester le son": "Test the sound",
  "Fermer": "Close",

  // ── Visite guidée ──
  "Fichier de correction": "Correction file",
  "Voir :": "View:",
  "Télécharger": "Download",
  "Le menu": "The menu",
  "Touche ici pour ouvrir toutes les rubriques : leçons, vidéos, exercices, évaluations, devoirs, messages…": "Tap here to open every section: lessons, videos, exercises, assessments, homework, messages…",
  "Ton tableau de bord": "Your dashboard",
  "Ton point de départ : ce que tu as fait, ce qui t'attend et les nouveautés.": "Your starting point: what you have done, what is waiting for you and what is new.",
  "Les leçons": "Lessons",
  "Les cours de ton manuel, chapitre par chapitre. Un point rouge signale une leçon que tu n'as pas encore ouverte.": "The lessons of your textbook, chapter by chapter. A red dot marks a lesson you have not opened yet.",
  "Les vidéos": "Videos",
  "Des explications en vidéo ; tu reprends là où tu t'étais arrêté.": "Video explanations; you resume where you stopped.",
  "Les exercices": "Exercises",
  "Entraîne-toi et demande l'aide d'un enseignant si tu bloques.": "Practise and ask a teacher for help if you get stuck.",
  "Les évaluations": "Assessments",
  "Les épreuves à traiter. Une épreuve « Obligatoire » doit être rendue avant son échéance.": "The tests to complete. A “Mandatory” test must be handed in before its deadline.",
  "Les devoirs": "Homework",
  "Tes devoirs à rendre : traite-les sur ta copie, scanne-la et envoie-la ici.": "Your homework to hand in: do it on paper, scan it and send it here.",
  "L'assistance": "Support",
  "Pose tes questions à un enseignant et suis ta place dans la file d'attente ; c'est aussi là que tu reçois tes corrections.": "Ask a teacher your questions and follow your place in the queue; this is also where you receive your corrections.",
  "La recherche": "Search",
  "Tape un titre ou un code (ex. MEC-LDN-QCM-01) pour trouver un contenu tout de suite.": "Type a title or a code (e.g. MEC-LDN-QCM-01) to find content right away.",
  "Les notifications": "Notifications",
  "Le point rouge t'indique une nouveauté ; il disparaît quand tu ouvres la rubrique concernée.": "The red dot shows something new; it disappears when you open the related section.",
  "Ta progression": "Your progress",
  "Ton avancement, tes prochains devoirs et tes épreuves obligatoires.": "Your progress, your next homework and your mandatory tests.",
  "Besoin d'aide ?": "Need help?",
  "Touche ce bouton pour revoir cette visite à tout moment.": "Tap this button to replay this tour at any time.",
  "Ton profil": "Your profile",
  "Ta photo, ta classe et tes informations personnelles.": "Your photo, your class and your personal details.",
  "Tu peux traiter en dehors de l'application : après avoir traité sur ta copie, scanne-la avec une application comme CamScanner et télécharge-la dans l'application avant de soumettre.": "You can work outside the app: once you have done it on paper, scan it with an app such as CamScanner and upload it to the app before submitting.",
  "Visite guidée": "Guided tour",
  "Étape": "Step",
  "Passer": "Skip",
  "Précédent": "Previous",
  "C'est parti !": "Let's go!",
  "Suivant": "Next",

  // ── Menu ──
  "Modules": "Modules",
  "Leçons": "Lessons",
  "Vidéos": "Videos",
  "Cours audio": "Audio lessons",
  "Exercices": "Exercises",
  "Ressources": "Resources",
  "Évaluations": "Assessments",
  "Devoirs": "Homework",
  "Mes résultats": "My results",
  "Favoris": "Favourites",
  "Notes": "Notes",
  "Calculatrice": "Calculator",
  "Formules utiles": "Useful formulas",
  "Hors connexion": "Offline",
  "Assistance": "Support",
  "Lives": "Lives",
  "QUICK LEARNING": "QUICK LEARNING",
  "ESPACE ÉLÈVE": "STUDENT SPACE",
  "Tableau de bord": "Dashboard",
  "ÉVALUER": "ASSESS",
  "Ma classe": "My class",
  "Mon code de parrainage": "My referral code",
  "Déconnexion": "Log out",
  "Menu": "Menu",
  "Code ou titre : MEC-LDN-QCM-01...": "Code or title: MEC-LDN-QCM-01...",
  "Ma progression": "My progress",
  "Aide — Comment ça marche ?": "Help — How does it work?",
  "Modifier mon profil": "Edit my profile",
  "Dashboard": "Dashboard",

  // ── Astuces ──
  "Révise régulièrement et n'hésite pas à refaire les exercices pour progresser davantage !": "Revise regularly and don't hesitate to redo exercises to keep improving!",
  "Bonne continuation ! 👍": "Keep it up! 👍",
  "La constance est la clé du succès. Même 20 minutes par jour peuvent faire une grande différence !": "Consistency is the key to success. Even 20 minutes a day can make a big difference!",
  "Tu peux le faire ! 💪": "You can do it! 💪",
  "N'aie pas peur de faire des erreurs — elles sont tes meilleures leçons. Analyse-les et avance !": "Don't be afraid of mistakes — they are your best lessons. Analyse them and move on!",
  "En avant ! 🚀": "Onwards! 🚀",
  "Chaque exercice résolu est une victoire. Continue à construire ta confiance pas à pas.": "Every solved exercise is a victory. Keep building your confidence step by step.",
  "Bravo pour tes efforts ! 🌟": "Well done for your efforts! 🌟",
  "Pose des questions à ton enseignant sans hésitation. Comprendre, c'est progresser.": "Ask your teacher questions without hesitation. Understanding is progressing.",
  "Courage ! 📚": "Keep going! 📚",
  "Révise tes leçons le soir même. La mémoire retient mieux ce qu'elle voit deux fois.": "Review your lessons the same evening. Memory retains better what it sees twice.",
  "Bonne étude ! 🎯": "Happy studying! 🎯",
  "Les grandes réussites commencent par de petits efforts quotidiens. Sois régulier et patient.": "Great achievements start with small daily efforts. Be regular and patient.",
  "On croit en toi ! ⭐": "We believe in you! ⭐",
  "Prends le temps de comprendre plutôt que de mémoriser. La compréhension dure toute la vie !": "Take time to understand rather than memorise. Understanding lasts a lifetime!",
  "Chaque leçon vue, chaque QCM passé te rapproche de ton objectif. Ne t'arrête pas !": "Every lesson viewed, every quiz taken brings you closer to your goal. Don't stop!",
  "Tu es sur la bonne voie ! 🏆": "You are on the right track! 🏆",
  "Organise ton temps d'étude : des sessions courtes et régulières valent mieux qu'une longue séance rare.": "Organise your study time: short regular sessions beat one long, rare session.",
  "Méthode et persévérance ! 📅": "Method and perseverance! 📅",
  "Astuce du jour": "Tip of the day",

  // ── Tableau de bord ──
  "Exercice résolu": "Exercise solved",
  "QCM terminé": "Quiz completed",
  "Vidéo regardée": "Video watched",
  "Hier": "Yesterday",
  "Ressource téléchargée": "Resource downloaded",
  "Assidu": "Diligent",
  "d'affilée": "in a row",
  "Connectez-vous chaque jour": "Log in every day",
  "Persévérant": "Persevering",
  "résolu": "solved",
  "Encore": "Again",
  "Bien joué": "Well done",
  "Score moyen :": "Average score:",
  "Passez un QCM": "Take a quiz",
  "% (seuil 70%)": "% (threshold 70%)",
  "Pas de date limite": "No deadline",
  "En retard": "Late",
  "de retard": "late",
  "Aujourd'hui": "Today",
  "Aujourd'hui !": "Today!",
  "Demain": "Tomorrow",
  "Urgent": "Urgent",
  "Dans": "In",
  "À rendre": "Due",
  "Cours & Leçons": "Courses & Lessons",
  "Cliquez sur une catégorie pour accéder directement aux ressources correspondantes.": "Click a category to go straight to its resources.",
  "Tout": "All",
  "En attente": "Pending",
  "Activités": "Activities",
  "Moy. QCM": "Quiz avg.",
  "Devoirs notés": "Graded homework",
  "Évals notées": "Graded assessments",
  "Aucun résultat dans cette catégorie pour l'instant.": "No results in this category yet.",
  "consultée": "viewed",
  "Aucune ressource consultée pour l'instant.": "No resource viewed yet.",
  "Regarde des vidéos et lis des leçons pour les retrouver ici !": "Watch videos and read lessons to find them here!",
  "Vidéos regardées": "Videos watched",
  "Leçons consultées": "Lessons viewed",
  "Bonjour": "Hello",
  "Prêt à continuer ton apprentissage aujourd'hui ?": "Ready to continue learning today?",
  "Modules étudiés": "Modules studied",
  "Exercices réalisés": "Exercises done",
  "Bien joué !": "Well done!",
  "Commence à apprendre !": "Start learning!",
  "Total cumulé": "Running total",
  "Continuer à apprendre": "Keep learning",
  "Récemment consultés": "Recently viewed",
  "Recommandé pour vous": "Recommended for you",
  "% terminé": "% complete",
  "Continuer": "Continue",
  "Dernière activité": "Last activity",
  "Pas encore commencé": "Not started yet",
  "Aucun module disponible.": "No module available.",
  "Voir tous mes modules": "See all my modules",
  "Activités récentes": "Recent activities",
  "Voir le détail": "See details",
  "Progression générale": "Overall progress",
  "Excellent ! Continue ainsi 🏆": "Excellent! Keep it up 🏆",
  "Très bien ! Tu progresses bien 👍": "Very good! You are progressing well 👍",
  "Bien ! Encore un effort 💪": "Good! One more effort 💪",
  "Assez bien, continue à travailler !": "Fairly good, keep working!",
  "Bon début ! Reviens chaque jour 📚": "Good start! Come back every day 📚",
  "Commence à apprendre pour voir ta progression !": "Start learning to see your progress!",
  "Cours": "Lessons",
  "QCM réussis": "Quizzes passed",
  "Très bien !": "Very good!",
  "Tu maîtrises bien les QCM": "You master the quizzes well",
  "Continue tes révisions": "Keep revising",
  "Révise tes leçons et réessaie": "Review your lessons and try again",
  "Prochains devoirs": "Upcoming homework",
  "Voir tout": "See all",
  "Aucun devoir à venir": "No upcoming homework",
  "Épreuves obligatoires": "Mandatory tests",
  "Aucune épreuve à rendre": "No test to hand in",
  "Corrigée": "Corrected",
  "Remise ✓": "Handed in ✓",
  "En attente de correction": "Awaiting correction",
  "Échéance dépassée": "Deadline passed",
  "Épreuve": "Test",
  "Mes badges": "My badges",
  "Voir tous": "See all",
  "Message": "Message",
  "Lundi": "Monday",
  "Mardi": "Tuesday",
  "Mercredi": "Wednesday",
  "Jeudi": "Thursday",
  "Vendredi": "Friday",
  "Samedi": "Saturday",
  "Dimanche": "Sunday",
  "Dim": "Sun",
  "Lun": "Mon",
  "Mar": "Tue",
  "Mer": "Wed",
  "Jeu": "Thu",
  "Ven": "Fri",
  "Sam": "Sat",
  "FÉV": "FEB",
  "AOÛ": "AUG",
  "DÉC": "DEC",

  // ── Notes et organisation ──
  "Notes & Organisation": "Notes & Planning",
  "Ma liste de tâches": "My to-do list",
  "Emploi du temps": "Timetable",
  "Ajouter une tâche…": "Add a task…",
  "Aucune tâche pour l'instant. Ajoute ta première tâche ci-dessus !": "No tasks yet. Add your first task above!",
  "À faire —": "To do —",
  "Marquer comme fait": "Mark as done",
  "Supprimer": "Delete",
  "Terminées —": "Completed —",
  "Marquer comme non fait": "Mark as not done",
  "Ajouter un créneau": "Add a slot",
  "Ton emploi du temps est vide.": "Your timetable is empty.",
  "Clique sur \"Ajouter un créneau\" pour commencer !": "Click \"Add a slot\" to start!",
  "Modifier": "Edit",
  "Modifier le créneau": "Edit the slot",
  "Nouveau créneau": "New slot",
  "Jour": "Day",
  "Matière / Activité": "Subject / Activity",
  "Ex: Mathématiques, Sport, Révisions…": "E.g. Maths, Sport, Revision…",
  "Début": "Start",
  "Fin": "End",
  "Couleur": "Colour",
  "Annuler": "Cancel",
  "Enregistrer": "Save",
  "Ajouter": "Add",
  "Sans échéance": "No deadline",
  "Les tâches n’ont pas pu être chargées.": "The tasks could not be loaded.",
  "L’emploi du temps n’a pas pu être chargé.": "The timetable could not be loaded.",
  "La tâche n’a pas pu être enregistrée.": "The task could not be saved.",
  "La tâche n’a pas pu être mise à jour.": "The task could not be updated.",
  "La tâche n’a pas pu être supprimée.": "The task could not be deleted.",
  "Le créneau n’a pas pu être enregistré.": "The slot could not be saved.",
  "Le créneau n’a pas pu être supprimé.": "The slot could not be deleted.",
  "Rouvrir": "Reopen",
  "Rappel": "Reminder",
  "Tâches": "Tasks",
  "Nouvelle note ou tâche": "New note or task",
  "Son des rappels": "Reminder sound",
  "Autoriser les notifications": "Allow notifications",
  "Notifications système refusées : les rappels restent visibles dans l’application ouverte.": "System notifications refused: reminders remain visible while the app is open.",
  "Aucune note ou tâche.": "No notes or tasks.",
  "À venir": "Upcoming",
  "Horaire": "Time",
  "Jour affiché": "Day shown",
  "Aucun créneau ce jour.": "No slot on this day.",
  "Modifier la tâche": "Edit the task",
  "Note ou tâche": "Note or task",
  "Échéance (facultative)": "Deadline (optional)",
  "Me rappeler à l’échéance": "Remind me at the deadline",
  "Une note sans échéance est enregistrée normalement, sans rappel.": "A note without a deadline is saved normally, without a reminder.",
  "Matière / activité": "Subject / activity",

  // ── Calculatrice ──
  "Erreur de syntaxe": "Syntax error",
  "Historique": "History",
  "Ex : sin(x), x^2, exp(-x^2)…": "E.g. sin(x), x^2, exp(-x^2)…",
  "Optionnel…": "Optional…",
  "Tracer": "Plot",
  "Entre une fonction et clique sur": "Enter a function and click",
  "Calculatrice scientifique": "Scientific calculator",
  "Tracer des fonctions": "Plot functions",

  // ── Modules, leçons, vidéos ──
  "Voir le PDF": "View the PDF",
  "Aperçu": "Preview",
  "Tous les modules": "All modules",
  "Aucune formule disponible pour le moment.": "No formula available yet.",
  "Cette section est en cours de développement. Revenez bientôt !": "This section is under development. Come back soon!",
  "Aucun module disponible pour le moment.": "No module available yet.",
  "leçon": "lesson",
  "vidéo": "video",
  "Ouvrir": "Open",
  "Aucune leçon disponible pour le moment.": "No lesson available yet.",
  "Module": "Module",
  "Lire": "Read",
  "Lien YouTube invalide.": "Invalid YouTube link.",
  "Voir la vidéo": "Watch the video",
  "Plein écran": "Full screen",
  "Pas de réseau : cette leçon n'a pas été gardée sur l'appareil.": "No network: this lesson was not saved on the device.",
  "Audios": "Audio",
  "Chargement...": "Loading...",
  "Chargement…": "Loading…",
  "Aucune leçon disponible pour ce module.": "No lesson available for this module.",
  "Liste des leçons": "List of lessons",
  "PDF non disponible": "PDF not available",
  "Aucune vidéo disponible pour ce module.": "No video available for this module.",
  "Aucun exercice disponible pour ce module.": "No exercise available for this module.",
  "Résoudre": "Solve",
  "Aucun QCM disponible pour ce module.": "No quiz available for this module.",
  "Commencer": "Start",
  "Aucune vidéo disponible.": "No video available.",
  "Aucun exercice disponible.": "No exercise available.",
  "Aucun QCM disponible.": "No quiz available.",
  "Formules": "Formulas",
  "Chapitres": "Chapters",
  "Afficher plus": "Show more",
  "Ce contenu n’est plus accessible. Actualisez votre abonnement ou votre manuel.": "This content is no longer available. Renew your subscription or your textbook.",

  // ── QCM et exercices ──
  "Impossible d'enregistrer le QCM. Vérifie ta connexion puis réessaie.": "Could not save the quiz. Check your connection and try again.",
  "🎉 Excellent !": "🎉 Excellent!",
  "👍 Bien !": "👍 Good!",
  "📚 À revoir": "📚 To review",
  "réponse": "answer",
  "Recommencer": "Start again",
  "Ce QCM ne contient encore aucune question.": "This quiz has no questions yet.",
  "Correct": "Correct",
  "Incorrect": "Incorrect",
  "Figure": "Figure",
  "❌ Image inaccessible — URL :": "❌ Image unavailable — URL:",
  "Bonne réponse :": "Correct answer:",
  "Retour": "Back",
  "Soumettre (": "Submit (",
  "Valeur exacte": "Exact value",
  "Fraction (ex : 2/3)": "Fraction (e.g. 2/3)",
  "Arrondi par excès à 10⁻³": "Rounded up to 10⁻³",
  "Arrondi par défaut à 10⁻³": "Rounded down to 10⁻³",
  "Erreur lors de la soumission.": "Error while submitting.",
  "Savoir-faire": "Skills",
  "Aucune question n'a encore été définie pour cet exercice.": "No question has been set for this exercise yet.",
  "Excellent travail !": "Excellent work!",
  "Assez bien, mais des erreurs subsistent": "Fairly good, but some mistakes remain",
  "À améliorer": "Needs improvement",
  "Note :": "Grade:",
  "Question": "Question",
  "/2 pts": "/2 pts",
  "Formule": "Formula",
  "Réponse": "Answer",
  "Valeur": "Value",
  "Formule(s) attendue(s) :": "Expected formula(s):",
  "Réponse attendue :": "Expected answer:",
  "Score inférieur à 50 %. Que souhaitez-vous faire ?": "Score below 50%. What would you like to do?",
  "Demande envoyée !": "Request sent!",
  "Un enseignant de la matière va vous aider.": "A teacher of the subject will help you.",
  "Corriger les questions ratées": "Correct the missed questions",
  "Score savoir-faire :": "Skills score:",
  "Envoi…": "Sending…",
  "Demander l'aide": "Ask for help",
  "Vous avez": "You have",
  "% — les réponses attendues s'affichent à partir de 80 %.": "% — the expected answers are shown from 80%.",
  "Retour aux exercices": "Back to exercises",
  "Corrigez uniquement les questions ratées — vos réponses correctes sont conservées.": "Correct only the missed questions — your correct answers are kept.",
  "Pour chaque question, saisissez la": "For each question, enter the",
  "utilisée": "used",
  "et la": "and the",
  "valeur / réponse": "value / answer",
  "1 point": "1 point",
  "(2 pts si tout est juste). Le clavier de maths s'ouvre sous chaque champ quand vous cliquez dessus.": "(2 pts if everything is right). The maths keyboard opens below each field when you click it.",
  "Déjà correct": "Already correct",
  "Ex : v = d/t": "E.g. v = d/t",
  "Valeur / Réponse": "Value / Answer",
  "Valeur numérique": "Numeric value",
  "Ex : 2/3": "E.g. 2/3",
  "Ex : conducteur": "E.g. conductor",
  "Ex : 1.414": "E.g. 1.414",
  "Correction en cours…": "Correcting…",
  "Soumettre les corrections": "Submit the corrections",
  "Soumettre toutes mes réponses": "Submit all my answers",
  "Correction de l'exercice": "Exercise correction",
  "Question de cours": "Lesson question",
  "Compétence": "Skill",
  "Exercice": "Exercise",
  "Bonne réponse !": "Correct answer!",
  "Votre réponse contient les éléments clés. Voici la correction :": "Your answer contains the key points. Here is the correction:",
  "Correction": "Correction",
  "Vous n'avez pas trouvé la solution": "You did not find the solution",
  "Votre réponse ne contient pas suffisamment d'éléments attendus pour cet exercice.": "Your answer does not contain enough of the expected points for this exercise.",
  "Un enseignant a reçu votre demande et vous aidera bientôt.": "A teacher has received your request and will help you soon.",
  "Souhaitez-vous recevoir une assistance d'un enseignant ?": "Would you like help from a teacher?",
  "Oui, demander de l'aide": "Yes, ask for help",
  "Non, continuer seul": "No, continue alone",
  "Réponse soumise !": "Answer submitted!",
  "Votre réponse a été enregistrée avec succès.": "Your answer has been saved.",
  "Votre réponse": "Your answer",
  "— tapez ci-dessous ou utilisez le clavier": "— type below or use the keyboard",
  "Tapez votre réponse ou utilisez le clavier scientifique…": "Type your answer or use the scientific keyboard…",
  "Insérer dans la réponse": "Insert into the answer",
  "Votre réponse n’a pas été enregistrée. Vérifiez votre connexion et réessayez.": "Your answer was not saved. Check your connection and try again.",
  "Soumettre ma réponse": "Submit my answer",
  "Réessayer": "Try again",

  // ── Abonnement ──
  "1 jour": "1 day",
  "Essai": "Trial",
  "7 jours": "7 days",
  "Semaine": "Week",
  "30 jours": "30 days",
  "Mensuel": "Monthly",
  "90 jours": "90 days",
  "Trimestriel": "Quarterly",
  "6 mois": "6 months",
  "Semestriel": "Half-yearly",
  "9 mois": "9 months",
  "Annuel": "Yearly",
  "Délai dépassé. Vérifiez votre téléphone et réessayez.": "Time limit exceeded. Check your phone and try again.",
  "Paiement échoué. Vérifiez votre solde et réessayez.": "Payment failed. Check your balance and try again.",
  "Veuillez entrer votre numéro de téléphone.": "Please enter your phone number.",
  "Le paiement est initialisé, mais la page CinetPay n’a pas pu être ouverte. Utilisez le bouton Réouvrir la page CinetPay.": "The payment has started, but the CinetPay page could not be opened. Use the Reopen the CinetPay page button.",
  "CinetPay n’a pas fourni de page de paiement.": "CinetPay did not provide a payment page.",
  "Erreur lors de l'initiation du paiement.": "Error while starting the payment.",
  "Renouveler mon abonnement": "Renew my subscription",
  "Paiement confirmé !": "Payment confirmed!",
  "Votre abonnement a été renouvelé.": "Your subscription has been renewed.",
  "Paiement en cours…": "Payment in progress…",
  "Effectuez votre paiement de": "Make your payment of",
  "sur la page CinetPay.": "on the CinetPay page.",
  "Cette fenêtre se mettra à jour automatiquement après confirmation.": "This window will update automatically after confirmation.",
  "Impossible d’ouvrir la page CinetPay.": "Could not open the CinetPay page.",
  "Réouvrir la page CinetPay": "Reopen the CinetPay page",
  "Choisissez votre forfait": "Choose your plan",
  "Populaire": "Popular",
  "Méthode de paiement": "Payment method",
  "Numéro de téléphone": "Phone number",
  "Entrez votre numéro sans le préfixe +237": "Enter your number without the +237 prefix",
  "Total à payer": "Total to pay",
  "Payer": "Pay",
  "Cliquer pour renouveler": "Click to renew",
  "Abonnement expiré — cliquez pour renouveler": "Subscription expired — click to renew",
  "Abonnement actif — expire le": "Subscription active — expires on",
  "Actualiser mon compte": "Refresh my account",
  "Renouveler": "Renew",

  // ── Lives ──
  "Commence dans": "Starts in",
  "🔴 EN DIRECT": "🔴 LIVE",
  "Relancer le lecteur si le live semble arrêté": "Restart the player if the live seems stuck",
  "Revoir": "Watch again",
  "Merci d'avoir participé !": "Thanks for taking part!",
  "Ce live est maintenant terminé. Tu as des questions ou des préoccupations sur les sujets abordés ?": "This live has now ended. Do you have questions or concerns about the topics covered?",
  "Envoie un message à ton enseignant directement sur la plateforme — il est là pour t'aider.": "Send your teacher a message directly on the platform — they are here to help you.",
  "Envoyer un message": "Send a message",
  "Fermer le replay": "Close the replay",
  "Revoir ce live": "Watch this live again",
  "Sessions en direct": "Live sessions",
  "Tous les lives": "All lives",
  "Quick Lives": "Quick Lives",
  "Aucune session live disponible pour l'instant.": "No live session available yet.",
  "Les lives seront visibles ici dès qu'ils sont programmés pour ton manuel.": "Lives will appear here as soon as they are scheduled for your textbook.",
  "Live terminé": "Live ended",
  "TERMINÉ": "ENDED",
  "En direct maintenant": "Live now",
  "Sessions à venir": "Upcoming sessions",
  "À VENIR": "UPCOMING",
  "Replays disponibles": "Available replays",

  // ── Résultats et activités ──
  "Devoir remis": "Homework handed in",
  "Évaluation remise": "Assessment handed in",
  "Excellent": "Excellent",
  "Très bien": "Very good",
  "Bien": "Good",
  "Passable": "Fair",
  "À l'instant": "Just now",
  "Il y a": "",
  "Aucune activité encore. Lance un QCM ou regarde une vidéo !": "No activity yet. Start a quiz or watch a video!",
  "Score :": "Score:",
  "Voir toutes mes activités": "See all my activities",
  "Vidéo": "Video",
  "Devoir": "Homework",
  "Évaluation": "Assessment",
  "activités": "activities",
  "activité": "activity",
  "Aucune activité trouvée.": "No activity found.",
  "Élève": "Student",
  "Classe": "Class",
  "Type": "Type",
  "Activité": "Activity",
  "Score": "Score",
  "Date": "Date",
  "Score (%)": "Score (%)",
  "Mes activités": "My activities",
  "QCM réalisés": "Quizzes taken",
  "réussis": "passed",
  "Exercices faits": "Exercises done",
  "Score moyen": "Average score",
  "Meilleur :": "Best:",
  "Temps d'apprentissage": "Learning time",
  "Temps total sur la plateforme": "Total time on the platform",
  "Devoirs remis": "Homework handed in",
  "corrigé": "corrected",
  "Évaluations remises": "Assessments handed in",
  "corrigée": "corrected",
  "Mention :": "Grade:",
  "Basée sur ton score moyen de": "Based on your average score of",
  "Évolution de tes scores": "Your scores over time",
  "évaluations": "assessments",
  "Aucune activité pour le moment.": "No activity yet.",
  "✓ Réussi": "✓ Passed",
  "✗ Échoué": "✗ Failed",
  "Réécouter": "Listen again",
  "Relire": "Read again",
  "Refaire": "Redo",
  "Vue": "Viewed",
  "Écouté": "Listened",
  "Déjà consultée": "Already viewed",
  "Déjà vue (100 %)": "Already watched (100%)",
  "Écouté (100 %)": "Listened (100%)",
  "Déjà réalisé": "Already done",
  "Dernière note :": "Last grade:",
  "Meilleure note :": "Best grade:",

  // ── Devoirs et évaluations ──
  "Lire le sujet": "Read the paper",
  "Télécharger le sujet": "Download the paper",
  "Pas de réseau : votre copie est gardée sur l'appareil et partira automatiquement dès le retour de la connexion. L'heure de réception par le serveur fera foi.": "No network: your work is kept on the device and will be sent automatically when the connection returns. The time it reaches the server is what counts.",
  "Ajoutez une réponse ou un fichier.": "Add an answer or a file.",
  "Fait ✓": "Done ✓",
  "Schéma de l'énoncé :": "Diagram of the statement:",
  "Schéma de l’énoncé, non à l’échelle.": "Diagram of the statement, not to scale.",
  "À rendre le": "Due on",
  "Corrigé —": "Corrected —",
  "Barème": "Marking scheme",
  "Devoir corrigé": "Homework corrected",
  "Correction du professeur": "Teacher's correction",
  "Devoir remis le": "Homework handed in on",
  "Modifier mon rendu": "Edit my submission",
  "Remettre le devoir": "Hand in the homework",
  "Réponse écrite (optionnel)": "Written answer (optional)",
  "Écrivez vos résultats, calculs, réponses…": "Write your results, calculations, answers…",
  "Fichier (photo ou PDF)": "File (photo or PDF)",
  "Fichier précédent :": "Previous file:",
  "Mon rendu": "My submission",
  "Mettre à jour": "Update",
  "Soumettre le devoir": "Submit the homework",
  "La note attribuée par le professeur est définitive. Le devoir ne peut plus être modifié. Si vous souhaitez contester votre note, vous pouvez contacter le professeur via la": "The grade given by the teacher is final. The homework can no longer be changed. If you wish to dispute your grade, you can contact the teacher through",
  "pour en discuter.": "to discuss it.",
  "Ton enseignant t'a envoyé la correction": "Your teacher has sent you the correction",
  "Voir la correction": "View the correction",
  "Télécharger la correction": "Download the correction",
  "Aucun devoir disponible pour l'instant.": "No homework available yet.",
  "Corrigé ✓": "Corrected ✓",
  "Évaluation corrigée": "Assessment corrected",
  "Évaluation remise le": "Assessment handed in on",
  "Remettre l'évaluation": "Hand in the assessment",
  "Écrivez vos réponses…": "Write your answers…",
  "Soumettre": "Submit",
  "La note attribuée par le professeur est définitive. L'évaluation ne peut plus être modifiée. Si vous souhaitez contester votre note, vous pouvez contacter le professeur via la": "The grade given by the teacher is final. The assessment can no longer be changed. If you wish to dispute your grade, you can contact the teacher through",
  "Aucune évaluation disponible pour l'instant.": "No assessment available yet.",
  "Obligatoire": "Mandatory",
  "Remis ✓": "Handed in ✓",
  "Masquer l'énoncé": "Hide the statement",
  "Voir l'énoncé": "Show the statement",
  "Énoncé": "Statement",
  "Sujet": "Paper",
  "Voir le sujet": "View the paper",
  "Voir le corrigé": "View the answer key",
  "Voir": "View",
  "Corrigé envoyé par l'enseignant": "Answer key sent by the teacher",
  "Commentaire du professeur :": "Teacher's comment:",
  "Masquer": "Hide",
  "Voir l'image": "View the image",
  "Ouvrir le PDF": "Open the PDF",
  "Sujets de devoirs": "Homework papers",
  "Sujets d'évaluations": "Assessment papers",
  "Mes épreuves générées": "My generated tests",

  // ── Messagerie ──
  "Ko": "KB",
  "Mo": "MB",
  "Message supprimé": "Message deleted",
  "📎 Document PDF": "📎 PDF document",
  "🎤 Message vocal": "🎤 Voice message",
  "🎥 Vidéo": "🎥 Video",
  "🖼 Image": "🖼 Image",
  "📝 Rendu :": "📝 Submission:",
  "✅ Correction :": "✅ Correction:",
  "✅ Corrigé envoyé": "✅ Answer key sent",
  "Messages": "Messages",
  "Nouveau message": "New message",
  "Action impossible.": "Action not possible.",
  "Erreur lors de l'envoi.": "Error while sending.",
  "Microphone non disponible.": "Microphone not available.",
  "Fichiers acceptés : images, PDF, vidéos.": "Accepted files: images, PDF, videos.",
  "Fichier trop lourd (max 10 Mo).": "File too large (max 10 MB).",
  "Impossible de rejoindre le groupe.": "Could not join the group.",
  "Erreur.": "Error.",
  "Impossible de modifier le message.": "Could not edit the message.",
  "Supprimer ce message ?": "Delete this message?",
  "Impossible de supprimer ce message.": "Could not delete this message.",
  "File d'assistance": "Support queue",
  "Conversations": "Conversations",
  "Toutes": "All",
  "Boîte de réception": "Inbox",
  "En cours": "In progress",
  "Terminées": "Completed",
  "Non lus": "Unread",
  "Groupes": "Groups",
  "Archivés": "Archived",
  "Rechercher une conversation...": "Search a conversation...",
  "Aucun groupe pour l'instant": "No groups yet",
  "Mes groupes": "My groups",
  "Aucune conversation": "No conversation",
  "Groupes à rejoindre": "Groups to join",
  "Professeur :": "Teacher:",
  "Exclu": "Excluded",
  "Complet": "Full",
  "Rejoindre": "Join",
  "Sélectionnez une conversation pour commencer": "Select a conversation to start",
  "Gérer les membres": "Manage members",
  "En ligne": "Online",
  "Hors ligne": "Offline",
  "Appeler en visio": "Video call",
  "Position :": "Position:",
  "Reçue à": "Received at",
  "· mise à jour": "· updated",
  "Membres du groupe": "Group members",
  "Répondre à ce message": "Reply to this message",
  "Modifier ce message": "Edit this message",
  "Supprimer ce message": "Delete this message",
  "Document PDF": "PDF document",
  "📝 Rendu de devoir": "📝 Homework submission",
  "✅ Correction de devoir": "✅ Homework correction",
  "📝 Rendu d'évaluation": "📝 Assessment submission",
  "✅ Correction d'évaluation": "✅ Assessment correction",
  "Entrée pour sauver · Échap pour annuler": "Enter to save · Esc to cancel",
  "Document": "Document",
  "évaluation": "assessment",
  "modifié": "edited",
  "Lu": "Read",
  "Envoyé": "Sent",
  "Annuler la réponse": "Cancel the reply",
  "Vous avez été bloqué dans ce groupe. Vous ne pouvez pas envoyer de messages.": "You have been blocked in this group. You cannot send messages.",
  "Vous avez été exclu de ce groupe.": "You have been removed from this group.",
  "Joindre une image, un PDF ou une vidéo": "Attach an image, a PDF or a video",
  "Maintenir pour enregistrer un message vocal": "Hold to record a voice message",
  "Dessiner une figure": "Draw a figure",
  "Clavier mathématique": "Maths keyboard",
  "Insérer dans le message": "Insert into the message",
  "Écrire un message…": "Write a message…",
  "Contacts fréquents": "Frequent contacts",
  "Informations utiles": "Useful information",
  "Heures d'assistance": "Support hours",
  "Lun - Ven : 8h00 - 22h00": "Mon - Fri: 8:00 am - 10:00 pm",
  "Temps de réponse moyen": "Average response time",
  "Moins de 24h": "Less than 24 h",
  "Conseils": "Tips",
  "Soyez précis dans vos questions.": "Be precise in your questions.",
  "Choisissez un contact": "Choose a contact",
  "Aucun contact.": "No contacts.",
  "Envoyer": "Send",
  "Envoi impossible.": "Sending failed.",
  "Demande d'aide": "Help request",
  "Réponse de l'élève :": "Student's answer:",
  "(aucune réponse rédigée)": "(no written answer)",
  "Réponse :": "Answer:",
  "Corrigé par": "Corrected by",
  "— Note :": "— Grade:",
  "Notifications": "Notifications",
  "Tout marquer comme lu": "Mark all as read",
  "Aucune notification": "No notifications",

  // ── Assistance ──
  "Temps de prise en charge estimé": "Estimated waiting time",
  "Prise en charge": "Being handled",
  "Ton enseignant s'occupe de ta question.": "Your teacher is working on your question.",
  "Estimation indicative, non garantie": "Indicative estimate, not guaranteed",
  "dans la file d'attente": "in the queue",
  "Enseignant :": "Teacher:",
  "Matière :": "Subject:",
  "Statut :": "Status:",
  "Mise à jour à": "Updated at",
  "Choisis la matière de ta question.": "Choose the subject of your question.",
  "Décris ton problème ou joins une photo de l'exercice.": "Describe your problem or attach a photo of the exercise.",
  "Envoi impossible. Réessaie.": "Sending failed. Try again.",
  "Nouvelle demande d'assistance": "New support request",
  "Aucun enseignant n'a encore renseigné ses matières.": "No teacher has set their subjects yet.",
  "Matière": "Subject",
  "en ligne": "online",
  "Ta question": "Your question",
  "Décris l'exercice et le point que tu ne comprends pas…": "Describe the exercise and the point you don't understand…",
  "Photo ou PDF de l'exercice (facultatif)": "Photo or PDF of the exercise (optional)",
  "Calcul du délai…": "Calculating the waiting time…",
  "Estimation indisponible.": "Estimate unavailable.",
  "Estimation indisponible": "Estimate unavailable",
  "Ta demande ira à": "Your request will go to",
  "(administrateur : aucun enseignant de cette matière n'est disponible)": "(administrator: no teacher of this subject is available)",
  "Délai estimé :": "Estimated wait:",
  "· tu serais": "· you would be",
  "dans sa file.": "in their queue.",
  "Les demandes sont réparties à parts égales entre les enseignants disponibles de la matière. Ensuite, tu pourras continuer l'échange avec tout le clavier : formules, dessin, fichiers et messages vocaux.": "Requests are shared equally between the available teachers of the subject. You can then continue the conversation with the full keyboard: formulas, drawing, files and voice messages.",
  "Envoyer ma demande": "Send my request",
  "Nouvelle demande": "New request",
  "Suivi de mes demandes": "My requests",
  "Prise en charge par": "Handled by",
  "dans la file ·": "in the queue ·",
  "Aucune demande en cours": "No request in progress",
  "Le suivi des demandes est momentanément indisponible.": "Request tracking is temporarily unavailable.",
  "Aucune demande en cours. Choisis la matière de ta question : le délai estimé s'affiche avant l'envoi.": "No request in progress. Choose the subject of your question: the estimated wait is shown before sending.",
  "Disponibilité par matière": "Availability by subject",
  "Aucune matière renseignée par les enseignants.": "No subject set by the teachers.",
  "💡 Pour être aidé rapidement": "💡 To get help quickly",
  "Indique ta classe, la matière et la question précise. Tu peux joindre une photo de l'exercice.": "Give your class, the subject and the precise question. You can attach a photo of the exercise.",
  "Une notification te préviendra dès qu'un enseignant prendra ta demande en charge.": "A notification will let you know as soon as a teacher takes on your request.",
  "Moins de 5 minutes": "Less than 5 minutes",
  "Moins de": "Less than",
  "en attente": "pending",
  "Terminée": "Completed",
  "Réattribuée": "Reassigned",
  "Disponible": "Available",
  "Occupé": "Busy",
  "Absent": "Away",
  "Enseignant": "Teacher",
  "Administrateur": "Administrator",
  "Directeur": "Director",
  "Comptable": "Accountant",
  "Secrétariat": "Secretariat",
  "Parent": "Parent",
  "Générateur d'épreuves": "Test generator",
  "Membre": "Member",

  // ── Profil ──
  "Recopiez exactement SUPPRIMER MON COMPTE pour confirmer.": "Type exactly SUPPRIMER MON COMPTE to confirm.",
  "Saisissez votre mot de passe actuel.": "Enter your current password.",
  "La suppression du compte n’a pas pu être effectuée.": "The account could not be deleted.",
  "Veuillez entrer votre mot de passe actuel.": "Please enter your current password.",
  "Veuillez entrer le nouveau mot de passe.": "Please enter the new password.",
  "Mot de passe insuffisant : 8 caractères minimum, une majuscule, un chiffre et un caractère spécial.": "Password too weak: at least 8 characters, one capital letter, one digit and one special character.",
  "Les mots de passe ne correspondent pas.": "The passwords do not match.",
  "Les mots de passe ne correspondent pas": "The passwords do not match",
  "Erreur lors de la mise à jour.": "Error while updating.",
  "Changer la photo": "Change the photo",
  "Mises à jour des informations effectuées.": "Your details have been updated.",
  "Informations générales": "General information",
  "Nom complet": "Full name",
  "Votre nom complet": "Your full name",
  "Adresse email": "Email address",
  "École / Établissement": "School",
  "Nom de votre école": "Name of your school",
  "— Sélectionner une classe —": "— Select a class —",
  "Téléphone": "Phone",
  "Ex : 6 99 99 99 99": "E.g. 6 99 99 99 99",
  "Date de naissance": "Date of birth",
  "Matières enseignées": "Subjects taught",
  "Chargement des matières…": "Loading subjects…",
  "Changer le mot de passe": "Change the password",
  "Mot de passe actuel": "Current password",
  "Votre mot de passe actuel": "Your current password",
  "Nouveau mot de passe": "New password",
  "8 car. min, majuscule, chiffre, spécial": "8 char. min, capital, digit, special",
  "8 caractères minimum": "At least 8 characters",
  "Une lettre majuscule": "One capital letter",
  "Un chiffre": "One digit",
  "Un caractère spécial (@, #, !, …)": "One special character (@, #, !, …)",
  "Masquer les suggestions": "Hide suggestions",
  "Suggérer des mots de passe mémorables": "Suggest memorable passwords",
  "Cliquez pour utiliser :": "Click to use:",
  "Notez votre mot de passe avant de valider.": "Write down your password before confirming.",
  "Confirmer le nouveau mot de passe": "Confirm the new password",
  "Répéter le nouveau mot de passe": "Repeat the new password",
  "Confidentialité et compte": "Privacy and account",
  "Impossible d’ouvrir la politique de confidentialité.": "Could not open the privacy policy.",
  "Politique de confidentialité": "Privacy policy",
  "Supprimer mon compte": "Delete my account",
  "Confirmation de suppression du compte": "Confirm account deletion",
  "Cette action supprime définitivement votre compte, votre profil, vos messages et votre progression. Les écritures financières légalement nécessaires sont conservées sans compte actif associé.": "This permanently deletes your account, profile, messages and progress. Legally required financial records are kept without an active account attached.",
  "Recopiez SUPPRIMER MON COMPTE": "Type SUPPRIMER MON COMPTE",
  "Suppression…": "Deleting…",
  "Confirmer la suppression": "Confirm deletion",
  "Enregistrement…": "Saving…",
  "Faible": "Weak",
  "Moyen": "Medium",
  "Bon": "Good",
  "Fort": "Strong",

  // ── Documents et téléchargements ──
  "Impression impossible.": "Printing failed.",
  "Imprimer": "Print",
  "Chargement du PDF…": "Loading the PDF…",
  "Fichier téléchargé avec succès.": "File downloaded.",
  "Votre session a expiré. Reconnectez-vous.": "Your session has expired. Please log in again.",
  "Fichier introuvable.": "File not found.",
  "Ce domaine de téléchargement n’est pas autorisé.": "This download domain is not allowed.",
  "Ce fichier existe déjà. Choisissez un autre nom.": "This file already exists. Choose another name.",
  "Le fichier est trop volumineux pour être téléchargé.": "The file is too large to download.",
  "Le fichier reçu est vide ou invalide.": "The file received is empty or invalid.",
  "Impossible d’enregistrer le fichier à cet emplacement.": "Could not save the file in this location.",
  "Le téléchargement a échoué. Vérifiez votre connexion puis réessayez.": "The download failed. Check your connection and try again.",
  "Téléchargement impossible.": "Download failed.",
  "Impression impossible pour ce fichier.": "This file cannot be printed.",
  "Cette action n’est pas disponible pour ce fichier.": "This action is not available for this file.",
  "Téléchargement…": "Downloading…",
  "le document": "the document",
  "Actions du fichier téléchargé": "Downloaded file actions",
  "Dossier": "Folder",
  "Partager": "Share",
  "Fermer les actions": "Close actions",
  "Téléchargement impossible. Vérifiez votre connexion.": "Download failed. Check your connection.",

  // ── Hors connexion ──
  "Garder hors connexion": "Keep offline",
  "Disponible sans Internet — cliquer pour retirer de l'appareil": "Available without Internet — click to remove from the device",
  "Télécharger sur l'appareil pour le lire sans Internet": "Download to the device to read it without Internet",
  "Mode hors connexion : vous consultez les contenus gardés sur l'appareil": "Offline mode: you are viewing content saved on the device",
  "(jusqu'au": "(until",
  "La génération et les paiements reprendront au retour du réseau.": "Generation and payments will resume when the network returns.",
  "Vos copies partiront au retour du réseau.": "Your work will be sent when the network returns.",
  "Mes contenus": "My content",
  "Copie envoyée :": "Work sent:",
  "copies préparées hors connexion ont été envoyées.": "pieces of work prepared offline have been sent.",
  "Copie non envoyée (": "Work not sent (",
  "Mes contenus hors connexion": "My offline content",
  "Accès sans Internet valable jusqu'au": "Offline access valid until",
  "(dans la limite de votre abonnement)": "(within your subscription)",
  "Pour garder une épreuve, touchez": "To keep a test, tap",
  "à côté de son sujet ou de sa correction dans « Mes épreuves ».": "next to its paper or its correction in “My tests”.",
  "Pour garder un contenu, touchez": "To keep content, tap",
  "à côté d'une leçon, d'un sujet, d'une formule ou d'un cours audio.": "next to a lesson, a paper, a formula or an audio lesson.",
  "Copies en attente d'envoi (": "Work waiting to be sent (",
  "Préparée le": "Prepared on",
  "— refusée :": "— refused:",
  "— envoi en cours…": "— sending…",
  "— partira au retour du réseau": "— will be sent when the network returns",
  "Retirer": "Remove",
  "Aucun contenu gardé sur cet appareil pour le moment.": "No content saved on this device yet.",
  "gardé le": "saved on",
  "Écouter": "Listen",
  "Espace utilisé :": "Space used:",

  // ── Manuels et audio ──
  "Impossible de changer de manuel.": "Could not switch textbook.",
  "Changer de manuel": "Switch textbook",
  "Choisir un manuel": "Choose a textbook",
  "Manuel actuel": "Current textbook",
  "Ouverture…": "Opening…",
  "Ouvrir ce manuel": "Open this textbook",
  "Non activé — entre son code à la connexion": "Not activated — enter its code when logging in",
  "Tu t'es arrêté à": "You stopped at",
  "Continuer à": "Continue at",
  "Position de lecture": "Playback position",
  "Reculer de 15 secondes": "Back 15 seconds",
  "Pause": "Pause",
  "Lecture": "Play",
  "Avancer de 15 secondes": "Forward 15 seconds",
  "Aucun cours audio pour le moment.": "No audio lesson yet.",

  // ── Recherche ──
  "Recherche…": "Searching…",
  "Recherche indisponible. Réessayez.": "Search unavailable. Try again.",
  "Aucun résultat pour «": "No results for “",

  // ── Appels vidéo ──
  "Impossible de démarrer l’appel.": "Could not start the call.",
  "Appel refusé.": "Call declined.",
  "Appel non répondu.": "Call not answered.",
  "L’appel a été annulé.": "The call was cancelled.",
  "Connexion à l’appel…": "Joining the call…",
  "Connecté": "Connected",
  "Connexion interrompue — reconnexion…": "Connection lost — reconnecting…",
  "Impossible de rejoindre l’appel.": "Could not join the call.",
  "Appel vidéo": "Video call",
  "Ouvrir les paramètres": "Open settings",
  "Préparation de l’appel…": "Preparing the call…",
  "Appel en cours…": "Call in progress…",
  "vous appelle en visio…": "is video calling you…",
  "Accepter": "Accept",
  "Refuser": "Decline",

  // ── Clavier mathématique et dessin ──
  "Aperçu ici…": "Preview here…",
  "Fraction": "Fraction",
  "Numérateur": "Numerator",
  "Dénominateur": "Denominator",
  "Puissance": "Power",
  "Base": "Base",
  "Exposant": "Exponent",
  "Indice": "Subscript",
  "Racine carrée": "Square root",
  "Radicande": "Radicand",
  "Racine n-ième": "n-th root",
  "Logarithme": "Logarithm",
  "ex: 2 (vide = 10)": "e.g. 2 (empty = 10)",
  "Argument": "Argument",
  "Logarithme naturel": "Natural logarithm",
  "Exponentielle": "Exponential",
  "Valeur absolue": "Absolute value",
  "Expression": "Expression",
  "Limite": "Limit",
  "Variable": "Variable",
  "Vers": "Towards",
  "Intégrale définie": "Definite integral",
  "Borne inf.": "Lower bound",
  "Borne sup.": "Upper bound",
  "Intégrande": "Integrand",
  "Somme (Σ)": "Sum (Σ)",
  "Produit (Π)": "Product (Π)",
  "Vecteur": "Vector",
  "Nom": "Name",
  "Matrice 2×2": "2×2 matrix",
  "a (ligne 1, col 1)": "a (row 1, col 1)",
  "b (ligne 1, col 2)": "b (row 1, col 2)",
  "c (ligne 2, col 1)": "c (row 2, col 1)",
  "Grec": "Greek",
  "Minuscules": "Lowercase",
  "Majuscules": "Uppercase",
  "Opérat.": "Operat.",
  "Arithmétique": "Arithmetic",
  "Exposants / Indices": "Exponents / Subscripts",
  "Fractions courantes": "Common fractions",
  "Radicaux / Sommes": "Roots / Sums",
  "Relations": "Relations",
  "Comparaisons": "Comparisons",
  "Proportionnalité": "Proportionality",
  "Calcul": "Calculus",
  "Intégrales / Dérivées": "Integrals / Derivatives",
  "Fonctions": "Functions",
  "Mesures": "Measures",
  "Ensembles": "Sets",
  "Corps de nombres": "Number fields",
  "Quantificateurs": "Quantifiers",
  "Géométrie": "Geometry",
  "Formes / Angles": "Shapes / Angles",
  "Congruence": "Congruence",
  "Flèches": "Arrows",
  "Simples": "Single",
  "Doubles": "Double",
  "Construire": "Build",
  "Symboles": "Symbols",
  "Prévisualisation": "Preview",
  "Entrez du LaTeX directement. L'expression sera entourée de": "Enter LaTeX directly. The expression will be wrapped in",
  "dans le message.": "in the message.",
  "Exemples rapides": "Quick examples",
  "Crayon (libre)": "Pencil (free)",
  "Ligne (corrigée)": "Line (straightened)",
  "Rectangle": "Rectangle",
  "Cercle": "Circle",
  "Triangle": "Triangle",
  "Texte (A, B, 1, 2…)": "Text (A, B, 1, 2…)",
  "Gomme": "Eraser",
  "Correction automatique des lignes": "Automatic line straightening",
  "Effacer tout": "Clear all",
  "Tapez puis Entrée…": "Type then press Enter…",
  "↵ Entrée pour valider · Esc pour annuler": "↵ Enter to confirm · Esc to cancel",
  "✨ Tracé libre — lignes presque droites corrigées automatiquement": "✨ Free drawing — almost straight lines are straightened automatically",
  "✏️ Tracé libre": "✏️ Free drawing",
  "╱ Glissez — ligne snappée sur 0°, 30°, 45°, 60°, 90°…": "╱ Drag — line snapped to 0°, 30°, 45°, 60°, 90°…",
  "□ Glissez pour tracer un rectangle": "□ Drag to draw a rectangle",
  "○ Glissez pour tracer une ellipse": "○ Drag to draw an ellipse",
  "△ Glissez pour tracer un triangle": "△ Drag to draw a triangle",
  "T Cliquez sur le canvas pour placer du texte (": "T Click the canvas to place text (",
  "⌫ Gomme — glissez pour effacer": "⌫ Eraser — drag to erase",

  "APPRENDRE": "LEARN",
  "PRINCIPAL": "MAIN",
  "COMPTE": "ACCOUNT",
  "OUTILS": "TOOLS",
  "COMMUNIQUER": "COMMUNICATE",
  "LIVE": "LIVE",
  "QCM": "Quizzes",
  "REPLAY": "REPLAY",
  "JOURS": "DAYS",
  "HEURES": "HOURS",
  "MIN": "MIN",
  "JAN": "JAN", "AVR": "APR", "MAI": "MAY", "JUN": "JUN", "JUL": "JUL", "SEP": "SEP", "OCT": "OCT", "NOV": "NOV",

  // ── Séances de soutien ──
  "Séances effectuées": "Completed sessions",
  "Après chaque cours, indiquez le jour, l'heure de début et l'heure de fin. Le montant du mois = heures déclarées × tarif horaire de l'enseignant.": "After each lesson, enter the day, start time and end time. The monthly amount = declared hours × the teacher's hourly rate.",
  "Déclarer la séance": "Declare the session",
  "Séance enregistrée.": "Session saved.",
  "Indiquez l'heure de début et l'heure de fin.": "Enter the start and end times.",
  "Retirer cette séance déclarée par erreur ?": "Remove this session declared by mistake?",
  "Une séance déclarée par erreur peut être retirée pendant 48 heures. L'enseignant et l'administration voient les mêmes séances et le même montant.": "A session declared by mistake can be removed within 48 hours. The teacher and the administration see the same sessions and the same amount.",
  "Aucune séance déclarée ce mois-ci.": "No session declared this month.",
  "Séances": "Sessions",
  "Heures": "Hours",
  "Tarif horaire": "Hourly rate",
  "Montant du mois": "Monthly amount",
  "Selon la matière": "Depends on the subject",
  "Séances et paiements": "Sessions and payments",
  "Séances et montants du mois": "Sessions and monthly amounts",
  "SÉANCES DÉCLARÉES ET MONTANT DU MOIS": "DECLARED SESSIONS AND MONTHLY AMOUNT",
  "Mois précédent": "Previous month",
  "Mois suivant": "Next month",
  "Vous pourrez noter cet enseignant et déclarer vos séances dès que l'administration vous aura mis en relation (demande confirmée).": "You will be able to rate this teacher and declare your sessions as soon as the administration has put you in touch (confirmed request).",
  "Touchez les étoiles pour donner une note de 1 à 5.": "Tap the stars to give a rating from 1 to 5.",
  "Pas encore d'avis": "No reviews yet",
  "Décevant": "Disappointing",
  "Confirmée — mise en relation": "Confirmed — put in touch",
  "NOTE QUICK LEARNING (CEO)": "QUICK LEARNING RATING (CEO)",
  "Assistant Quick Learning": "Quick Learning assistant",
  "Akili répond aux questions sur l'utilisation de votre espace, à partir de l'aide préparée par l'équipe (sans IA en ligne).": "Akili answers questions about using your space, from help written by the team (no online AI).",
  "Ouvrir Akili, l'assistant Quick Learning": "Open Akili, the Quick Learning assistant",
  "Akili, l'assistant Quick Learning": "Akili, the Quick Learning assistant",
  "Fermer Akili": "Close Akili",
  "Akili écrit": "Akili is typing",
  "Aucune note": "No rating",
  "/5 · Note Quick Learning": "/5 · Quick Learning rating",
  "avis de parents": "parent reviews",
  "Seul le CEO peut attribuer cette note.": "Only the CEO can give this rating.",
  "Touchez une étoile pour noter. Les parents la voient sous le nom « Note Quick Learning », à côté de la moyenne de leurs propres notes.": "Tap a star to rate. Parents see it as the “Quick Learning rating”, next to the average of their own ratings.",

  // ── Divers ──
  "Oui": "Yes",
  "Non": "No",
  "OK": "OK",
  "Valider": "Confirm",
  "Confirmer": "Confirm",
};

// Textes composés (gabarits) : [expression, remplacement].
export const MOTIFS_EN = [
  [/^Assistant Quick Learning · Espace (.+)$/, "Quick Learning assistant · $1 space"],
  [/^Il y a (\d+) ?min$/, "$1 min ago"],
  [/^Il y a (\d+) ?h$/, "$1 h ago"],
  [/^Il y a (\d+) ?j$/, "$1 d ago"],
  [/^Il y a (\d+) jours?$/, "$1 days ago"],
  [/^Score : (.+)$/, "Score: $1"],
  [/^Voir : (.+)$/, "View: $1"],
  [/^Nouveau message de (.+)$/, "New message from $1"],
  [/^Demande d'assistance de (.+)$/, "Support request from $1"],
  [/^Nouvelle leçon : (.+)$/, "New lesson: $1"],
  [/^Nouvelle vidéo : (.+)$/, "New video: $1"],
  [/^Nouvel exercice : (.+)$/, "New exercise: $1"],
  [/^Nouveau QCM : (.+)$/, "New quiz: $1"],
  [/^Nouveau devoir : (.+)$/, "New homework: $1"],
  [/^Nouvelle évaluation : (.+)$/, "New assessment: $1"],
  [/^Devoir corrigé : (.+)$/, "Homework corrected: $1"],
  [/^Évaluation corrigée : (.+)$/, "Assessment corrected: $1"],
  [/^(\d+) disponibles?$/, "$1 available"],
  [/^(\d+)(?:er|e) dans la file d'attente$/, "No. $1 in the queue"],
  [/^Prise en charge par (.+)$/, "Handled by $1"],
  [/^Mise à jour à (.+)$/, "Updated at $1"],
  [/^Moins de (\d+) minutes$/, "Less than $1 minutes"],
  [/^Environ (\d+) minutes$/, "About $1 minutes"],
  [/^(\d+) membres$/, "$1 members"],
  [/^(\d+)\/(\d+) membres$/, "$1/$2 members"],
  [/^Abonnement actif — expire le (.+)$/, "Subscription active — expires on $1"],
  [/^(\d+) exercices? résolus?$/, "$1 exercise(s) solved"],
  [/^(\d+) jours? d'affilée$/, "$1 day(s) in a row"],
  [/^(\d+) jours? restants?$/, "$1 day(s) left"],
  [/^Encore (\d+) exercices?$/, "$1 more exercise(s)"],
  [/^Score moyen : (\d+)% \(seuil 70%\)$/, "Average score: $1% (threshold 70%)"],
  [/^Score moyen : (.+)$/, "Average score: $1"],
  [/^(\d+) jours?$/, "$1 day(s)"],
  [/^(\d+) non lus?$/, "$1 unread"],
];

// Espace élève prioritaire en cas de doublon.
const EN = { ...EN_ESPACES, ...EN_ELEVE };

export default EN;
